import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./coreServices.css"

import IoTImage from "../../assests/iot-solution.svg"; 
import RoboticsImage from "../../assests/robotic-solution.svg"; 
import rpaimg from "../../assests/rpa-img.svg"
const CoreServices = () => {
  return (
    <div style={{display:"flex",justifyContent:"center"}}>
    <div className="pt-5 core-service-head">
        <h2 className=" mb-2  core-h2">Performance & Automation at Scale</h2>
        <p className="text-center performance-p-services mb-5">Connect devices | Streamline processes | Increase efficiency</p>

        {/* IoT Solutions */}
        <Row className="align-items-center mb-5  card-image-1-01 card-padding-iot">
          <Col md={7} xs={12}>
            <div className="p-4  h-100">
              <h4 className=" mb-4 core-h4">Edge IoT Integration </h4>
              <ul className="mb-0 core-ul">
                <li>
                  Connect devices across<span className="bold-span"> edge and cloud networks </span>for real-time data collection and analysis. 
                </li>
                <li>
                  Enable<span className="bold-span"> smart operations and predictive analytics </span>for manufacturing, logistics, and enterprise systems. 
                </li>
                {/* <li>
                  Enable remote monitoring and control through <span className="bold-span">IoT dashboards</span>
                  and cloud platforms.
                </li>
                <li>
                  Integrate IoT with <span className="bold-span">AI/ML for intelligent automation</span> and
                  smarter decision-making.
                </li>
                <li>
                  Transform operations into connected ecosystems for<span className="bold-span"> enhanced
                  efficiency</span> and scalability.
                </li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-end mt-3 mt-md-0">
            <img src={IoTImage} alt="IoT Solutions" className="img-fluid" />
          </Col>
        </Row>

        {/* Robotics Solutions */}
        <Row className="align-items-center mb-5 flex-md-row-reverse  card-image-2-01 card-padding-iot">
          <Col md={7} xs={12}>
            <div className="p-4  h-100">
              <h4 className=" mb-4 core-h4">Computer Vision for IoT</h4>
              <ul className="mb-0 core-ul">
                <li>
                  Implement <span className="bold-span">AI-powered computer vision solutions</span> for real-time monitoring and automated insights. 
                </li>
                <li>
                  Enhance operational safety, efficiency, and quality control with<span className="bold-span"> intelligent IoT vision systems</span>. 
                </li>
                {/* <li>
                  Develop intelligent robots that can sense, adapt, and act in
                  dynamic environments.
                </li>
                <li>
                  <span className="bold-span">Integrate robotics with IoT and AI</span> for coordinated, smart, and
                  self-learning systems.
                </li>
                <li>
                  Deliver solutions that boost productivity, safety, and
                  operational efficiency.
                </li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-start mt-3 mt-md-0">
            <img
              src={RoboticsImage}
              alt="Robotics Solutions"
              className="img-fluid"
            />
          </Col>
        </Row>

        <Row className="align-items-center mb-5  card-image-1-02 card-padding-iot">
          <Col md={7} xs={12}>
            <div className="p-4  h-100">
              <h4 className=" mb-4 core-h4">Robotic Process Automation (RPA) </h4>
              <ul className="mb-0 core-ul">
                <li>
                  Automate repetitive workflows using <span className="bold-span">RPA bots</span> to increase productivity.  
                </li>
                <li>
                 Free employees for <span className="bold-span">higher-value tasks</span> while ensuring process accuracy and compliance. 
                </li>
                {/* <li>
                  Enable remote monitoring and control through <span className="bold-span">IoT dashboards</span>
                  and cloud platforms.
                </li>
                <li>
                  Integrate IoT with <span className="bold-span">AI/ML for intelligent automation</span> and
                  smarter decision-making.
                </li>
                <li>
                  Transform operations into connected ecosystems for<span className="bold-span"> enhanced
                  efficiency</span> and scalability.
                </li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-end mt-3 mt-md-0">
            <img src={rpaimg} alt="IoT Solutions" className="img-fluid" />
          </Col>
        </Row>

        
    </div>
    </div>
  );
};

export default CoreServices;
